import { Button, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFileImportProfileList extends Layout {
    buttonCopy: Button;
    buttonImport: Button;
    searchpanelList: SearchPanel;
    sourceFileImportProfileList: DataSource;
    tableFileImportProfile: Table;
    textboxDataTypeSearch: Textbox;
    textboxDescrSearch: Textbox;
    textboxFieldNameSearch: Textbox;
    textboxIdSearch: Textbox;
    textboxTableNameSearch: Textbox;
}
